import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@mui/material';
import { download } from '@glowforge/builder-components/lib/util/image-helpers';
import { MagicSvgImageShape } from '../../context/MagicSvgContext/MagicSvgProvider';
import MagicSvgIconButton from './magic-svg-icon-button';
import CopyIconMobile from './icons/copy-mobile.svg';
import CopyIconDesktop from './icons/copy-desktop.svg';
import DownloadIconMobile from './icons/download-mobile.svg';
import DownloadIconDesktop from './icons/download-desktop.svg';

function MagicSvgShare({
  isMobile,
  image,
  hideCopy,
  hideDownload,
}) {
  const [open, setOpen] = useState(false);

  const handleDownload = async () => {
    try {
      const fileName = image.prompt || image.additionalFields.userText;
      await download(image.svgUrl, `${fileName.replace(/\s+/g, '-')}.svg`);
    } catch (e) {
      console.error('Error downloading:', e);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setOpen(true);
    } catch (e) {
      console.error('Error copying:', e);
    }
  };

  return (
    <>
      {!hideDownload && (
        <MagicSvgIconButton
          icon={isMobile ? <DownloadIconMobile /> : <DownloadIconDesktop />}
          onClick={handleDownload}
          tooltip='Download'
        />
      )}
      {!hideCopy && (
        <MagicSvgIconButton
          icon={isMobile ? <CopyIconMobile /> : <CopyIconDesktop />}
          onClick={handleCopy}
          tooltip='Copy link'
        />
      )}
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={() => setOpen(false)}
        message='Link copied'
      />
    </>
  );
}

MagicSvgShare.propTypes = {
  isMobile: PropTypes.bool,
  image: PropTypes.shape(MagicSvgImageShape).isRequired,
  hideCopy: PropTypes.bool,
  hideDownload: PropTypes.bool,
};

MagicSvgShare.defaultProps = {
  isMobile: false,
  hideCopy: false,
  hideDownload: false,
};

export default MagicSvgShare;
